export class ODataPagedResult<T> {
  data: T[];
  count: number;
  nextLink: string;
}
